/**
 * Hide / strip RecurPay default PDP widgets (custom BrewNectar plans own the UI).
 * Intentionally light — no document-wide MutationObserver (that lagged the cart drawer).
 */
(function () {
  var SELECTORS = [
    '.recurpay-pdp-widget',
    '.recurpay__widget',
    '[data-recurpay-widget]',
    '[class*="recurpay-pdp"]'
  ].join(',');

  function strip() {
    document.querySelectorAll(SELECTORS).forEach(function (el) {
      if (el && el.parentNode) el.parentNode.removeChild(el);
    });
  }

  function run() {
    strip();
    // RecurPay may inject shortly after load; a couple delayed passes is enough
    setTimeout(strip, 400);
    setTimeout(strip, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  window.addEventListener('load', strip);
})();
